import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AppService } from 'app/app.service';

@Injectable({
    providedIn: 'root'
})
export class FuseCreateTaskService
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private appService: AppService)
    {
    }
    
    getAllUsers() {
        return this._httpClient.get(this.appService.getApiUrl() + 'user/list');
    }

    getAllTeams() {
        return this._httpClient.get(this.appService.getApiUrl() + 'teams/list');
    }

    addTask(payload: any){
        return this._httpClient.post(
            this.appService.getApiUrl() + 'tasks/add',
            payload
        );
    }
}
